import { render, staticRenderFns } from "./PlayerBan.vue?vue&type=template&id=b997c08e&"
import script from "./PlayerBan.vue?vue&type=script&lang=js&"
export * from "./PlayerBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports